<div class="modal" (click)="clickOuside()">
  <div class="modal-content" (click)="stopPropagation($event)">
    <div class="modal-header"> {{ header }} </div>
    <div class="modal-body">
      <ng-container *ngIf="msgExplication">
        <div class="msg-wrapper" [style.maxWidth]="options.msgWrapperMaxWidth">{{ msgExplication }}</div>
        <br>
      </ng-container>
      <div class="msg-wrapper" [style.maxWidth]="options.msgWrapperMaxWidth">{{ msgQuestion }}</div>
      <div class="button-wrapper">
        <frg-button *ngFor="let p of arrayPropositions"
          [backgroundColor]="p.backgroundColor ? p.backgroundColor : 'var(--primary)'" fullWidth="true"
          (activated)="closeConfirmationModal(p.value)">
          {{ p.label }}</frg-button>
          <frg-button [type]="'reset'" (activated)="closeConfirmationModal(null)" fullWidth="true"
            [backgroundColor]="'var(--darkest-primary)'">Fermer
        </frg-button>
      </div>           
    </div>
  </div>
</div>
<div class="modal-background"></div>
